import { motion } from "framer-motion";

export default function WheelVisual({ className = "" }) {
  return (
    <div className={`relative ${className}`} data-testid="hero-wheel-visual">
      <motion.svg
        viewBox="0 0 200 200"
        className="h-full w-full"
        animate={{ rotate: 360 }}
        transition={{ duration: 26, ease: "linear", repeat: Infinity }}
      >
        <defs>
          <radialGradient id="tireG" cx="50%" cy="50%" r="50%">
            <stop offset="62%" stopColor="#0b0f16" />
            <stop offset="88%" stopColor="#1a2230" />
            <stop offset="100%" stopColor="#080b10" />
          </radialGradient>
        </defs>
        <circle cx="100" cy="100" r="96" fill="url(#tireG)" stroke="#FFC400" strokeOpacity="0.5" strokeWidth="1.5" />
        <circle cx="100" cy="100" r="58" fill="#0e131c" stroke="#FFC400" strokeOpacity="0.65" strokeWidth="1.5" />
        {Array.from({ length: 14 }).map((_, i) => (
          <rect key={i} x="97" y="6" width="6" height="16" rx="3" fill="#FFC400" opacity={i % 3 === 0 ? 1 : 0.35} transform={`rotate(${(360 / 14) * i} 100 100)`} />
        ))}
        {Array.from({ length: 6 }).map((_, i) => (
          <rect key={i} x="94" y="36" width="12" height="34" rx="6" fill="#232d3f" transform={`rotate(${i * 60} 100 100)`} />
        ))}
        <circle cx="100" cy="100" r="12" fill="#FFC400" />
        <circle cx="100" cy="100" r="5" fill="#080B10" />
      </motion.svg>
    </div>
  );
}
